var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md_center"},[_c('img',{attrs:{"src":"/assets/img/htc.jpg"}}),_c('div',{staticClass:"flex-col"},[_c('p',[_vm._v(_vm._s(_vm.$t("widgets.htcCount.title")))]),_c('h3',[_vm._v(_vm._s(_vm.htcCountData))])])])}
var staticRenderFns = []

export { render, staticRenderFns }